import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';

import { CustomValidators } from 'ng2-validation';
import { IMyOptions, IMyDateModel } from 'mydatepicker';

import { AppSettings } from "../../../shared/app-settings";
import { AddNofeshService } from "./add-nofesh.service";
import { INofeshDdlData } from "../../model/nofesh-ddl-data";
import { INofesh } from "../../model/nofesh";
import { UploadService } from '../../../shared/upload.service';
import { ConfigService } from "app/shared/config.service";


@Component({
    moduleId: module.id,
    templateUrl: './add-nofesh.component.html',
    providers: [AddNofeshService, UploadService]
})



export class AddNofeshComponent implements OnInit {
    constructor(private _http: AddNofeshService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private _uploadService: UploadService,
        private _configService: ConfigService) {

         this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");   
        this._uploadService.progress$.subscribe(
            data => {
                console.log('progress = ' + data);
            });
    }
    
    
    apiUrl: string  = ""
    tkufatRishumError: string = '';
    tkufatNofeshError: string = '';

    form: FormGroup;
    nofeshDdlData: INofeshDdlData;
    nofeshAdd: INofesh;
    is_submited: boolean = false;
    nofeshTitle: string = "הוספת נופש";
    nofeshId: number;
    currDate: Date = new Date();
    files: File[];
    fileName: string;
    errorMessage: string;


    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: AppSettings.dayLabels,
        monthLabels: AppSettings.monthLabels,
        showTodayBtn: false,
        firstDayOfWeek: 'su',
        alignSelectorRight: true,
        disableSince: { year: this.currDate.getFullYear() + 3, month: this.currDate.getMonth() + 1, day: this.currDate.getDate() - 1 },
        disableUntil: { year: this.currDate.getFullYear(), month: this.currDate.getMonth() + 1, day: this.currDate.getDate() - 1 },
    };

    ngOnInit(): void {

        document.getElementById('menuDiv').style.display = 'none';

        // in case of update this will be false.
        this.nofeshId = this.route.snapshot.params['id']
        if (this.nofeshId != null && this.nofeshId != undefined) {
            this.nofeshTitle = "עדכון נופש";
        }

        this.form = this.fb.group({
            nofeshId: [''],
            nofeshTitle: ['', [Validators.required]],
            //totalpeaple: ['', [Validators.required, CustomValidators.gt(0)]],
            nofeshType: ['', [Validators.required, CustomValidators.gt(0)]],
            fromTkufatRishum: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],//fromTkufatRishum,
            toTkufatRishum: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
            fromTkufatNofesh: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],//fromTkufatNofesh,
            toTkufatNofesh: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
            total_rooms: ['', [Validators.required, CustomValidators.gt(0)]],
            total_peaple: ['', [Validators.required, CustomValidators.gt(0)]],
            max_adults_in_room: ['', [Validators.required, CustomValidators.gt(0)]],
            max_child_in_room: [null],
            boardType: ['', [Validators.required]],
            company: ['', [Validators.required]],
            companySite: ['', CustomValidators.url],
            hotelName: [''],
            hotel_star_rating: [''],
            heara1: [''],
            heara2: [''],
            heara3: [''],
            total_hamtana_people: ['', [Validators.required]],
            total_hamtana_room: [''],
            child_min_age: [null],
            child_max_age: [null],
            id_nofesh_mekushar: [''],
            id_machzor: [''],
            ms_mkomot_pnimi:[''], 
            alut_mesubsedet_pnimi:[''],
            prices: this.fb.array([
                this.initPrices(),
            ])
        })

        this._http.getNofeshDdlData()
            .subscribe(r => { this.nofeshDdlData = r; })

        if (this.nofeshId) {
            if (this.nofeshId > 0) {
                this._http.getNofesh(this.nofeshId)
                    .subscribe(res => {

                        if (res.id_nofesh == 0) {
                            // nofesh not found
                            this.nofeshTitle = "הוספת נופש";
                            return;
                        }
                        this.nofeshAdd = res;
                        let fromTkufatRishum_date = new Date(res.fromTkufatRishum);
                        let toTkufatRishum_date = new Date(res.toTkufatRishum);
                        let fromTkufatNofesh_date = new Date(res.fromTkufatNofesh);
                        let toTkufatNofesh_date = new Date(res.toTkufatNofesh)
                        this.form.patchValue({
                            nofeshId: this.nofeshAdd.id_nofesh,
                            nofeshTitle: this.nofeshAdd.nofeshTitle,
                            nofeshType: this.nofeshAdd.nofeshType,
                            boardType: this.nofeshAdd.boardType,
                            hotelName: this.nofeshAdd.hotelName,
                            hotel_star_rating: this.nofeshAdd.hotel_star_rating,
                            company: this.nofeshAdd.company,
                            companySite: this.nofeshAdd.companySite,
                            total_peaple: this.nofeshAdd.total_peaple,
                            total_rooms: this.nofeshAdd.total_rooms,
                            max_adults_in_room: this.nofeshAdd.max_adults_in_room,
                            max_child_in_room: this.nofeshAdd.max_child_in_room,
                            heara1: this.nofeshAdd.heara1,
                            heara2: this.nofeshAdd.heara2,
                            heara3: this.nofeshAdd.heara3,
                            total_hamtana_people: this.nofeshAdd.total_hamtana_people,
                            total_hamtana_room: this.nofeshAdd.total_hamtana_room,
                            child_min_age: this.nofeshAdd.child_min_age,
                            child_max_age: this.nofeshAdd.child_max_age,
                            fromTkufatRishum: { date: { year: fromTkufatRishum_date.getFullYear(), month: fromTkufatRishum_date.getMonth() + 1, day: fromTkufatRishum_date.getDate() } },
                            toTkufatRishum: { date: { year: toTkufatRishum_date.getFullYear(), month: toTkufatRishum_date.getMonth() + 1, day: toTkufatRishum_date.getDate() } },
                            fromTkufatNofesh: { date: { year: fromTkufatNofesh_date.getFullYear(), month: fromTkufatNofesh_date.getMonth() + 1, day: fromTkufatNofesh_date.getDate() } },
                            toTkufatNofesh: { date: { year: toTkufatNofesh_date.getFullYear(), month: toTkufatNofesh_date.getMonth() + 1, day: toTkufatNofesh_date.getDate() } },
                            id_nofesh_mekushar: this.nofeshAdd.id_nofesh_mekushar,
                            id_machzor: this.nofeshAdd.id_machzor, 
                            ms_mkomot_pnimi:this.nofeshAdd.ms_mkomot_pnimi, 
                            alut_mesubsedet_pnimi:this.nofeshAdd.alut_mesubsedet_pnimi

                        })

                        if (res.prices.length > 0) {
                            this.removePrices(0);
                            for (let price of res.prices) {
                                this.addPrices(price.id_price_type, price.price_rate, price.id_currency);
                            }
                        }
                    }, error => {
                        console.log(error);
                        if (error.includes("401")) {
                            localStorage.removeItem("token");
                            location.reload();
                        }
                    })
            }
        }
    }

    initPrices(id_price_type?, price_rate?, id_curreny?) {

        if (id_price_type == null)
            id_price_type = '';
        if (price_rate == null)
            price_rate = '';
        if (id_curreny == null)
            id_curreny = '';

        return this.fb.group({
            id_price_type: [id_price_type, Validators.required],
            price_rate: [price_rate, Validators.required],
            id_currency: [id_curreny, Validators.required]
        });
    }



    addPrices(id_price_type?, price_rate?, id_curreny?) {
        const control = <FormArray>this.form.controls['prices'];
        control.push(this.initPrices(id_price_type, price_rate, id_curreny));
    }

    removePrices(i: number) {
        const control = <FormArray>this.form.controls['prices'];
        control.removeAt(i);
    }

    compareTwoDates() {

        if (new Date(this.form.controls['toTkufatRishum'].value) < new Date(this.form.controls['fromTkufatRishum'].value)) {

        }
    }

    onFromTkufatRishumChanged(event: IMyDateModel) {
        this.tkufatRishumError = '';

        if (!this.form.controls['toTkufatRishum'].value)
            return; //there is nothing to compare to

        let end = this.form.controls['toTkufatRishum'].value;

        let startDate = new Date(event.jsdate);
        let endDate = new Date(end.date.year, end.date.month - 1, end.date.day);

        if (!this.IsDatesRangeValid(startDate, endDate)) {
            this.tkufatRishumError = 'תאריך סיום רישום חייב להיות גדול או שווה לתאריך תחילת הרישום';
        }
    }

    onToTkufatRishumChanged(event: IMyDateModel) {
        this.tkufatRishumError = '';

        if (!this.form.controls['fromTkufatRishum'].value)
            return; //there is nothing to compare to

        let start = this.form.controls['fromTkufatRishum'].value;

        let startDate = new Date(start.date.year, start.date.month - 1, start.date.day);
        let endDate = new Date(event.jsdate);


        if (!this.IsDatesRangeValid(startDate, endDate)) {
            this.tkufatRishumError = 'תאריך סיום רישום חייב להיות גדול או שווה לתאריך תחילת הרישום';
        }

    }

    onFromTkufatNofeshChanged(event: IMyDateModel) {
        this.tkufatNofeshError = '';

        if (!this.form.controls['toTkufatNofesh'].value)
            return; //there is nothing to compare to

        let end = this.form.controls['toTkufatNofesh'].value;

        let startDate = new Date(event.jsdate);
        let endDate = new Date(end.date.year, end.date.month - 1, end.date.day);

        if (!this.IsDatesRangeValid(startDate, endDate)) {
            this.tkufatNofeshError = 'תאריך סיום רישום חייב להיות גדול או שווה לתאריך תחילת הרישום';
        }
    }

    onToTkufatNofeshChanged(event: IMyDateModel) {
        this.tkufatNofeshError = '';

        if (!this.form.controls['fromTkufatNofesh'].value)
            return; //there is nothing to compare to

        let start = this.form.controls['fromTkufatNofesh'].value;

        let startDate = new Date(start.date.year, start.date.month - 1, start.date.day);
        let endDate = new Date(event.jsdate);


        if (!this.IsDatesRangeValid(startDate, endDate)) {
            this.tkufatNofeshError = 'תאריך סיום רישום חייב להיות גדול או שווה לתאריך תחילת הרישום';
        }
    }

    IsDatesRangeValid(start: Date, end: Date): boolean {
        return start <= end;
    }

    save(model: INofesh) {
        debugger;
        model.id_nofesh = this.nofeshId > 0 ? this.nofeshId : 0;
        model.fromTkufatRishum = this.setDate(this.form.value.fromTkufatRishum.date);// this.form.value.fromTkufatRishum.jsdate;
        model.toTkufatRishum = this.setDate(this.form.value.toTkufatRishum.date);
        model.fromTkufatNofesh = this.setDate(this.form.value.fromTkufatNofesh.date);
        model.toTkufatNofesh = this.setDate(this.form.value.toTkufatNofesh.date);

        this.errorMessage = '';

        this._http.addNofesh(model)
            .subscribe(r => {
                if (r.status == true) {

                    if (this.files) {
                        let param: string[] = [r.id_nofesh.toString()];
                        this._uploadService.makeFileRequest(`${this.apiUrl}/api/Nofesh/saveNofeshCilabus`, param, this.files).subscribe(() => {
                            console.log('sent');
                        });
                    }

                    this.router.navigate(['nofesh-admin', 'nofashim']);
                }
                else {
                    //Failed To Save
                    this.errorMessage = r.returnMessage;
                }
            }, error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }
            }
            )
    }

    setDate(m): Date {

        return new Date(Date.UTC(m.year, m.month - 1, m.day));
        //return new Date(m.year + '-' + m.month + '-' + m.day);
    }

    fileChange($event) {

        this.files = null;
        this.fileName = "";

        if ($event.srcElement.files[0].size / 1024 / 1024 > 10) {
            this.fileName = "גודל הקובץ חורג מהמותר. הקובץ לא יצורף.";
            return;
        }

        if ("pdf".indexOf($event.srcElement.files[0].name.split('.').pop().toLowerCase()) == -1) {
            this.fileName = "קובץ לא תקין. הקובץ לא יצורף.";
            return;
        }

        this.files = $event.srcElement.files;
        this.fileName = $event.srcElement.files[0].name;
    }

    removefile() {
        this.files = null;
        this.fileName = "";
    }
}

